module.exports = __webpack_public_path__ + "img/3.5a6ca6d6.jpg";